/* Gallery lightbox — progressive enhancement.

   Without this file every photo is still a plain link to the full-size image,
   so the gallery works with JavaScript off; this just keeps you on the page.

   Keyboard: arrows move, Escape closes, focus returns to the thumbnail you
   opened from. */
(function () {
  // A page with several galleries loads this file once per gallery. Run once:
  // each copy used to build its own viewer, so one click opened them all stacked.
  if (window.fhGalleryReady) return;
  window.fhGalleryReady = true;
  var grids = document.querySelectorAll('[data-fh-gallery]');
  if (!grids.length) return;

  var box, imgEl, capEl, counter, opener, items = [], idx = 0;

  // Labels come from the page (locales gallery.*), so they follow the language.
  function label(name, fallback) {
    return (grids[0].getAttribute('data-label-' + name) || fallback).replace(/[&<>"]/g, '');
  }
  function build() {
    box = document.createElement('div');
    box.className = 'fh-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', label('viewer', 'Photograph viewer'));
    box.hidden = true;
    box.innerHTML =
      '<img class="fh-lightbox__img" alt="">' +
      '<div class="fh-lightbox__bar">' +
        '<button type="button" data-prev aria-label="' + label('previous', 'Previous photograph') + '">&larr;</button>' +
        '<span data-count></span>' +
        '<button type="button" data-next aria-label="' + label('next', 'Next photograph') + '">&rarr;</button>' +
        '<span class="fh-lightbox__caption" data-cap></span>' +
        '<button type="button" data-close aria-label="' + label('close-viewer', 'Close viewer') + '">' + label('close', 'Close') + '</button>' +
      '</div>';
    document.body.appendChild(box);
    imgEl = box.querySelector('.fh-lightbox__img');
    capEl = box.querySelector('[data-cap]');
    counter = box.querySelector('[data-count]');
    box.querySelector('[data-close]').addEventListener('click', close);
    box.querySelector('[data-prev]').addEventListener('click', function () { step(-1); });
    box.querySelector('[data-next]').addEventListener('click', function () { step(1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
  }

  // The viewer used to wait for the 2400px file before showing anything, so a
  // click looked like it did nothing. Now: show the thumbnail the page already
  // has at once, fetch a 1600px copy in the background and swap it in, and
  // preload the neighbours so the arrows are instant. The link itself still
  // points at the full-size file for downloading.
  var cache = {};
  function viewSrc(a) {
    return a.getAttribute('href').replace(/([?&]width=)\d+/, function (m, k) { return k + '1600'; });
  }
  function preload(a) {
    var u = viewSrc(a);
    if (!cache[u]) { cache[u] = new Image(); cache[u].src = u; }
    return cache[u];
  }
  function show(i) {
    idx = (i + items.length) % items.length;
    var a = items[idx];
    var inner = a.querySelector('img');
    var want = viewSrc(a);
    var pre = preload(a);
    if (pre.complete && pre.naturalWidth) {
      imgEl.src = want;
      box.classList.remove('is-loading');
    } else {
      imgEl.src = inner ? (inner.currentSrc || inner.src) : want;
      box.classList.add('is-loading');
      pre.onload = function () {
        if (viewSrc(items[idx]) === want) { imgEl.src = want; box.classList.remove('is-loading'); }
      };
    }
    imgEl.alt = inner ? inner.getAttribute('alt') || '' : '';
    capEl.textContent = a.getAttribute('data-caption') || '';
    counter.textContent = (idx + 1) + ' / ' + items.length;
    preload(items[(idx + 1) % items.length]);
    preload(items[(idx - 1 + items.length) % items.length]);
  }
  function step(d) { show(idx + d); }

  function open(list, i, from) {
    if (!box) build();
    items = list; opener = from;
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    show(i);
    box.querySelector('[data-close]').focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    box.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (opener) opener.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') step(1);
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'Tab') {
      // Keep Tab inside the viewer; the page behind it is covered.
      var stops = box.querySelectorAll('button');
      var first = stops[0], last = stops[stops.length - 1];
      if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  grids.forEach(function (grid) {
    var links = Array.prototype.slice.call(grid.querySelectorAll('[data-fh-gallery-item]'));
    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;   // let people open in a new tab
        e.preventDefault();
        open(links, i, a);
      });
    });
  });
})();
